import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-charter-price-detail-dialog',
  templateUrl: './view-images-dialog.component.html',
  styleUrls: ['./view-images-dialog.component.scss'],
})
export class ViewImagesDialogComponent implements OnInit, OnDestroy {
  imageUrl: string;
  fileName: string;

  constructor(
    public dialogRef: MatDialogRef<ViewImagesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.imageUrl = this.data.imageUrlToOpen;
    this.fileName = this.getFileName();
  }

  ngOnDestroy() {}

  getFileName(): string {
    const splitUrl = this.imageUrl.split('/');
    return splitUrl[splitUrl.length - 1] + '.jpeg';
  }
}
